var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Alert',{attrs:{"layout":"center","level":"medium","theme":"warning"}},[_vm._v("\n  "+_vm._s(_vm.$t('components.offlineAlert.message'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }